import WorkflowAPI from "./workflow.api";
import { CosmoformTemplate } from "@/core/Models/Cosmoform";
//#region Collaborators > Workflow - Service
export function getOrganizationCollaborators(organizationId, page) {
  return WorkflowAPI.getOrganizationCollaborators(organizationId, page);
}

export function getCollaboratorAssignedToStatus(
  organizationId,
  workflowId,
  statusId
) {
  return WorkflowAPI.fetchAssignedCollaboratorStatus(
    organizationId,
    workflowId,
    statusId
  );
}

//#endregion
//#region Organization > Workflow - Service
export function fetchOrganizationWorkflows(organizationId, page, is_ready) {
  return WorkflowAPI.getOrganizationWorkflows({
    organizationId,
    params: {
      page,
      is_ready,
    },
  });
}
export function postOrganisationWorkflowStatusMove(payload) {
  return WorkflowAPI.postOrganisationWorkflowStatusMove(payload);
}

export function fetchOrganizationWorkflow(organizationId, workflowId) {
  return WorkflowAPI.getOrganizationWorkflow(organizationId, workflowId);
}

export function postOrganizationWorkflow(organizationId, payload) {
  return WorkflowAPI.postOrganizationWorkflow(organizationId, payload);
}

export function patchOrganizationWorkflow(organizationId, workflowId, data) {
  let payload = {};
  if (data.name !== undefined) {
    payload.name = data.name;
  }
  if (data.primary_status !== undefined) {
    payload.primary_status = data.primary_status;
  }
  if (data.nexus_folder_creation_enabled !== undefined) {
    payload.nexus_folder_creation_enabled = data.nexus_folder_creation_enabled;
  }
  if (data.nexus_folder_name_input_label !== undefined) {
    payload.nexus_folder_name_input_label = data.nexus_folder_name_input_label;
  }
  if (data.nexus_folder_create_button_label !== undefined) {
    payload.nexus_folder_create_button_label =
      data.nexus_folder_create_button_label;
  }
  if (data.nexus_folder_assigned_collaborator !== undefined) {
    payload.nexus_folder_assigned_collaborator =
      data.nexus_folder_assigned_collaborator;
  }
  if (data.send_collection_emails !== undefined) {
    payload.send_collection_emails = data.send_collection_emails;
  }
  if (data.state) payload.state = data.state;
  return WorkflowAPI.patchOrganizationWorkflow(
    organizationId,
    workflowId,
    payload
  );
}

export function deleteOrganizationWorkflow(organizationId, workflowId) {
  return WorkflowAPI.deleteOrganizationWorkflow(organizationId, workflowId);
}

//#endregion
//#region Organization > Workflow > Status > Collaborator - Service
export function addCollaboratorStatus(
  collaboratorId,
  organizationId,
  statusId,
  workflowId
) {
  return WorkflowAPI.addCollaboratorToStatus(
    collaboratorId,
    organizationId,
    statusId,
    workflowId
  );
}

export function delCollaboratorStatus(
  organizationId,
  workflowId,
  statusId,
  assignStatusId
) {
  return WorkflowAPI.delCollaboratorToStatus(
    organizationId,
    workflowId,
    statusId,
    assignStatusId
  );
}

//#endregion
//#region Organization > Workflow > Status - Service
export function postOrganizationWorkflowStatus(
  organizationId,
  workflowId,
  payload
) {
  return WorkflowAPI.postOrganizationWorkflowStatus(
    organizationId,
    workflowId,
    payload
  );
}

export function patchOrganizationWorkflowStatus(
  organizationId,
  workflowId,
  statusId,
  data
) {
  let payload = {};
  if (data.name !== undefined) {
    payload.name = data.name;
  }
  return WorkflowAPI.patchOrganizationWorkflowStatus(
    organizationId,
    workflowId,
    statusId,
    payload
  );
}

export function deleteOrganizationWorkflowStatus(
  organizationId,
  workflowId,
  statusId
) {
  return WorkflowAPI.deleteOrganizationWorkflowStatus(
    organizationId,
    workflowId,
    statusId
  );
}

//#endregion
//#region Organization > Workflow > Status > Question - Service
export function fetchorganizationWorkflowStatusQuestions(
  organizationId,
  workflowId,
  statusId,
  page
) {
  return WorkflowAPI.fetchorganizationWorkflowStatusQuestions(
    organizationId,
    workflowId,
    statusId,
    page
  );
}

export async function postOrganizationWorkflowStatusQuestion(
  organizationId,
  workflowId,
  statusId,
  payload
) {
  let formData = new FormData();
  formData.append("name", payload.name);
  formData.append("label", payload.label);
  if (payload.readOnly) formData.append("read_only", payload.readOnly);
  if (payload.hasFreeOption)
    formData.append("has_free_option", payload.hasFreeOption);
  payload.typeQuestion
    ? formData.append("type_question", payload.typeQuestion)
    : null;
  payload.slug ? formData.append("slug", payload.slug) : null;
  payload.required ? formData.append("required", payload.required) : null;
  payload.helpText ? formData.append("help_text", payload.helpText) : null;
  payload.helpFile ? formData.append("help_file", payload.helpFile) : null;
  payload.category ? formData.append("category", payload.category) : null;
  const response = await WorkflowAPI.postOrganizationWorkflowStatusQuestion(
    organizationId,
    workflowId,
    statusId,
    formData
  );
  if (payload.choices && payload.choices.length) {
    if (Array.isArray(payload.choices)) {
      let promises = [];
      payload.choices.forEach((choice) => {
        promises.push(
          WorkflowAPI.postOrganizationWorkflowStatusQuestionOption(
            organizationId,
            workflowId,
            statusId,
            response.data.id,
            { name: choice.name, slug: choice.slug, order: choice.order }
          )
        );
      });
      const responses = await Promise.all(promises);
      responses.forEach((item) => {
        response.data.choices.push(item.data);
      });
    } else {
      await WorkflowAPI.postOrganizationWorkflowStatusQuestionOptionBulkCreate(
        organizationId,
        workflowId,
        statusId,
        response.data.id,
        { choices: payload.choices }
      );
    }
  }
  return response.data;
}

export async function postOrganisationWorkflowStatusDatatypeQuestion({
  organizationId,
  workflowId,
  statusId,
  payload,
}) {
  let formData = new FormData();
  formData.append("name", payload.name);
  formData.append("label", payload.label);
  if (payload.readOnly) formData.append("read_only", payload.readOnly);
  payload.datatype ? formData.append("datatype", payload.datatype) : null;
  payload.required ? formData.append("required", payload.required) : null;
  payload.helpText ? formData.append("help_text", payload.helpText) : null;
  payload.helpFile ? formData.append("help_file", payload.helpFile) : null;
  payload.category ? formData.append("category", payload.category) : null;

  const res = await WorkflowAPI.postOrganisationWorkflowStatusDatatypeQuestion({
    organizationId,
    workflowId,
    statusId,
    payload: formData,
  });
  return res.data;
}

export function updateOrganizationWorkflowStatusQuestion(
  organizationId,
  workflowId,
  statusId,
  questionId,
  payload,
  deletedOptionsIds
) {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    if (payload.slug !== undefined) formData.append("slug", payload.slug);
    if (payload.name !== undefined) formData.append("name", payload.name);
    if (payload.label !== undefined) formData.append("label", payload.label);
    if (payload.order) formData.append("order", payload.order);
    if (payload.readOnly !== undefined)
      formData.append("read_only", payload.readOnly);
    if (payload.typeQuestion !== undefined)
      formData.append("type_question", payload.typeQuestion);
    if (payload.required !== undefined)
      formData.append("required", payload.required);
    if (payload.helpText !== undefined)
      formData.append("help_text", payload.helpText);
    if (payload.helpFile !== undefined)
      formData.append("help_file", payload.helpFile ? payload.helpFile : "");
    if (payload.has_free_option !== undefined)
      formData.append("has_free_option", payload.has_free_option);
    formData.append("category", payload.category ? payload.category : "");

    payload.datatype ? formData.append("datatype", payload.datatype) : null;

    WorkflowAPI.patchOrganizationWorkflowStatusQuestion(
      organizationId,
      workflowId,
      statusId,
      questionId,
      formData
    )
      .then((res) => {
        const editedQuestion = res.data;
        if (payload.choices && payload.choices.length > 0) {
          /* Delete options */
          deletedOptionsIds.forEach(async (id) => {
            await WorkflowAPI.deleteOrganizationWorkflowStatusQuestionOption(
              organizationId,
              workflowId,
              statusId,
              questionId,
              id
            );
          });
          /* Edit question options */
          payload.choices
            .filter((choice) => choice.id)
            .forEach(async (choice) => {
              await WorkflowAPI.patchOrganizationWorkflowStatusQuestionOption(
                organizationId,
                workflowId,
                statusId,
                questionId,
                choice.id,
                { name: choice.name, order: choice.order }
              ).then((choice) =>
                editedQuestion.choices
                  .filter((c) => c.id != choice.data.id)
                  .push(choice.data)
              );
            });
          /* create question options */
          payload.choices
            .filter((choice) => !choice.id)
            .forEach(async (choice) => {
              await WorkflowAPI.postOrganizationWorkflowStatusQuestionOption(
                organizationId,
                workflowId,
                statusId,
                questionId,
                { name: choice.name, slug: choice.slug, order: choice.order }
              ).then((choice) => editedQuestion.choices.push(choice.data));
            });
        }
        resolve(editedQuestion);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export function deleteOrganizationWorkflowStatusQuestion(
  organizationId,
  workflowId,
  statusId,
  questionId
) {
  return WorkflowAPI.deleteOrganizationWorkflowStatusQuestion(
    organizationId,
    workflowId,
    statusId,
    questionId
  );
}

//#endregion
//#region Organization > Workflow > Status > Question > Answer - Service
export function postOrganizationFolderStatusQuestionAnswer({
  organizationId,
  folderId,
  statusId,
  questionId,
  payload,
}) {
  return WorkflowAPI.postOrganizationFolderStatusQuestionAnswer({
    organizationId,
    folderId,
    statusId,
    questionId,
    payload,
  });
}

export function patchOrganizationFolderStatusQuestionAnswer({
  organizationId,
  folderId,
  statusId,
  questionId,
  answerId,
  payload,
}) {
  return WorkflowAPI.patchOrganizationFolderStatusQuestionAnswer({
    organizationId,
    folderId,
    statusId,
    questionId,
    answerId,
    payload,
  });
}

export function deleteOrganizationFolderStatusQuestionAnswer(
  organizationId,
  folderId,
  statusId,
  questionId,
  answerId
) {
  return WorkflowAPI.deleteOrganizationFolderStatusQuestionAnswer(
    organizationId,
    folderId,
    statusId,
    questionId,
    answerId
  );
}

//#endregion
//#region Organization > Workflow > Status > Question > Option - Service
export function fetchOrganizationWorkflowStatusQuestionOptions(
  organizationId,
  workflowId,
  statusId,
  questionId
) {
  return WorkflowAPI.getOrganizationWorkflowStatusQuestionOptions(
    organizationId,
    workflowId,
    statusId,
    questionId
  ).then((res) => res.data.results);
}

//#endregion
//#region Organization > Workflow > Status > Action - Service
export function fetchOrganizationWorkflowStatusActions({
  organizationId,
  workflowId,
  statusId,
  page,
}) {
  return WorkflowAPI.getOrganizationWorkflowStatusActions({
    organizationId,
    workflowId,
    statusId,
    page,
  });
}
export function postOrganizationWorkflowStatusAction({
  organizationId,
  workflowId,
  statusId,
  actionId,
}) {
  return WorkflowAPI.postOrganizationWorkflowStatusAction({
    organizationId,
    workflowId,
    statusId,
    actionId,
  });
}

export function deleteOrganizationWorkflowStatusAction({
  organizationId,
  workflowId,
  statusId,
  actionId,
}) {
  return WorkflowAPI.deleteOrganizationWorkflowStatusAction({
    organizationId,
    workflowId,
    statusId,
    actionId,
  });
}

//#endregion
//#region Organization > Workflow > Status > TargetStatus - Service
export function createOrganizationWorkflowStatusTargetStatus(
  organizationId,
  workflowId,
  statusId,
  payload
) {
  return WorkflowAPI.postOrganizationWorkflowStatusTargetStatus(
    organizationId,
    workflowId,
    statusId,
    payload
  );
}

export function fetchOrganizationWorkflowStatusTargetStatuses(
  organizationId,
  workflowId,
  statusId
) {
  return WorkflowAPI.getOrganizationWorkflowStatusTargetStatuses(
    organizationId,
    workflowId,
    statusId
  );
}

export function getOrganizationWorkflowStatusUsage({
  organizationId,
  workflowId,
  statusId,
}) {
  return WorkflowAPI.getOrganizationWorkflowStatusUsage({
    organizationId,
    workflowId,
    statusId,
  });
}

export function postOrganizationWorkflowStatusReminder({
  organizationId,
  workflowId,
  statusId,
  payload,
}) {
  return WorkflowAPI.postOrganizationWorkflowStatusReminder({
    organizationId,
    workflowId,
    statusId,
    payload,
  });
}

export function updateOrganizationWorkflowStatusTargetStatus(
  organizationId,
  workflowId,
  statusId,
  targetStatusId,
  payload
) {
  return WorkflowAPI.patchOrganizationWorkflowStatusTargetStatus(
    organizationId,
    workflowId,
    statusId,
    targetStatusId,
    payload
  );
}

export function deleteOrganizationWorkflowStatusTargetStatus(
  organizationId,
  workflowId,
  statusId,
  targetStatusId
) {
  return WorkflowAPI.deleteOrganizationWorkflowStatusTargetStatus(
    organizationId,
    workflowId,
    statusId,
    targetStatusId
  );
}
export async function createOrganizationFolderCosmoform({
  organizationId,
  folderId,
  payload,
}) {
  return await WorkflowAPI.postOrganizationFolderCosmoformSubmit({
    organizationId,
    folderId,
    payload,
  });
}

export async function postOrganizationWorkflowCosmoformTemplate({
  organizationId,
  workflowId,
  payload,
}) {
  return await WorkflowAPI.postOrganizationWorkflowCosmoformTemplate({
    organizationId,
    workflowId,
    payload,
  });
}

export async function getOrganizationWorkflowCosmoformTemplateUsage({
  organizationId,
  workflowId,
  templateId,
}) {
  return await WorkflowAPI.getOrganizationWorkflowCosmoformTemplateUsage({
    organizationId,
    workflowId,
    templateId,
  });
}

export async function deleteOrganizationWorkflowCosmoformTemplate({
  organizationId,
  workflowId,
  templateId,
}) {
  return await WorkflowAPI.deleteOrganizationWorkflowCosmoformTemplate({
    organizationId,
    workflowId,
    templateId,
  });
}

export async function patchOrganizationWorkflowCosmoformTemplate({
  organizationId,
  workflowId,
  payload,
  templateId,
}) {
  return await WorkflowAPI.patchOrganizationWorkflowCosmoformTemplate({
    organizationId,
    workflowId,
    payload,
    templateId,
  });
}

export async function getOrganizationWorkflowCosmoformTemplate({
  organizationId,
  workflowId,
  filters,
}) {
  let res = await WorkflowAPI.getOrganizationWorkflowCosmoformTemplate({
    organizationId,
    workflowId,
    filters,
  });
  return {
    item: res.data.results.map((ct) => new CosmoformTemplate(ct)),
    count: res.data.count,
  };
}

export async function getOrganizationCosmoformTemplate({
  organizationId,
  filters,
}) {
  let res = await WorkflowAPI.getOrganizationCosmoformTemplate({
    organizationId,
    filters,
  });
  return {
    item: res.data.results.map((ct) => new CosmoformTemplate(ct)),
    count: res.data.count,
  };
}

export async function getOrganizationCosmoformTemplateDetail({
  organizationId,
  cosmoformTemplateId,
}) {
  let res = await WorkflowAPI.getOrganizationCosmoformTemplateDetail({
    organizationId,
    cosmoformTemplateId,
  });
  return res.data;
}
export async function getWorkflowQuestions({
  organizationId,
  workflowId,
  page,
  pageSize,
  typeQuestion,
  name,
  slug,
  std_only,
}) {
  let res = await WorkflowAPI.getWorkflowQuestions({
    organizationId,
    workflowId,
    page,
    pageSize,
    typeQuestion,
    name,
    slug,
    std_only,
  });
  return {
    items: res.data.results,
    count: res.data.count,
    next: res.data.next,
    previous: res.data.previous,
    page: res.data.page,
  };
}

export async function getFormEligibleQuestions({
  organizationId,
  workflowId,
  queryParams,
}) {
  let res = await WorkflowAPI.getFormEligibleQuestions({
    organizationId,
    workflowId,
    queryParams,
  });
  return {
    items: res.data.results,
    count: res.data.count,
    next: res.data.next,
    previous: res.data.previous,
    page: res.data.page,
  };
}
export async function getTemplateEligibleQuestions({
  organizationId,
  workflowId,
  queryParams,
}) {
  let res = await WorkflowAPI.getTemplateEligibleQuestions({
    organizationId,
    workflowId,
    queryParams,
  });
  return {
    items: res.data.results,
    count: res.data.count,
    next: res.data.next,
    previous: res.data.previous,
    page: res.data.page,
  };
}
